import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ForbiddenService {
  public readonly forbidden$ = new BehaviorSubject<boolean>(false);

  public show(): void {
    this.forbidden$.next(true);
  }

  public hide(): void {
    this.forbidden$.next(false);
  }
}
